import { jsx } from 'react/jsx-runtime';

const SvgMiscStepsAlt = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M21 5h-9v2h9V5ZM17 11H8v2h9v-2ZM12 17H3v2h9v-2Z" }) }));

export { SvgMiscStepsAlt as default };
//# sourceMappingURL=MiscStepsAlt.es.js.map
